import React from "react";
import { datasetColorVar } from "@/lib/datasetColor";

const SIZE = {
  sm: "h-1.5 w-1.5",
  md: "h-2 w-2",
  lg: "h-2.5 w-2.5",
} as const;

/// A space's swatch; `color` is its palette name (`spaceColor(space)`).
export const SpaceDot: React.FC<{
  color: string;
  size?: keyof typeof SIZE;
  className?: string;
}> = ({ color, size = "md", className }) => (
  <span
    aria-hidden
    className={`${SIZE[size]} shrink-0 rounded-app${className ? ` ${className}` : ""}`}
    style={{ backgroundColor: datasetColorVar(color) }}
  />
);
